import { z } from "zod";

export const WorkflowExecutionLogSchema = z.object({
	id: z.string(),
	workflowId: z.string(),
	message: z.string(),
	gyulUsed: z.number(),
	createdAt: z.string(),
});

export const WorkflowErrorLogSchema = z.object({
	title: z.string(),
	description: z.string(),
	url: z.string().nullable(),
});

export const GetExecutionLogsResponseSchema = z.object({
	logs: z.array(WorkflowExecutionLogSchema),
	monthGyulUsed: z.number(),
});

export const GetErrorLogsResponseSchema = z.object({
	errors: z.array(WorkflowErrorLogSchema),
});

export type WorkflowExecutionLog = z.infer<typeof WorkflowExecutionLogSchema>;
export type WorkflowErrorLog = z.infer<typeof WorkflowErrorLogSchema>;
export type GetExecutionLogsResponse = z.infer<typeof GetExecutionLogsResponseSchema>;
export type GetErrorLogsResponse = z.infer<typeof GetErrorLogsResponseSchema>;
